/** 
 * Shared hardware/payments framing copy used across Coupling sites.
 * Sites can override these by creating their own copy.ts.
 */
export const HARDWARE_FRAMING = 'Tap to Pay on your phone, or an optional Stripe reader.';
export const HARDWARE_FRAMING_LONG =
  'Take cards with Tap to Pay on the phone you already have, or add an optional Stripe reader available through Coupling.';
